import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import '../../styles/common/modal.css';

const SaveConfirmModal = ({ 
  isOpen, 
  onConfirm, 
  onCancel, 
  hasApplication = false,
  hasDraft = false,
  isConfirmation = false,
  actionType = 'navigate' // 'navigate', 'draft', 'submit'
}) => {
  // 모달이 열리면 페이지 스크롤 방지
  useEffect(() => {
    if (isOpen) {
      // 모달이 열리면 배경 스크롤 방지
      document.body.style.overflow = 'hidden';
      
      // 컴포넌트 언마운트 시 원래대로 복원
      return () => {
        document.body.style.overflow = 'auto';
      };
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const getModalContent = () => {
    console.log('[SaveConfirmModal] getModalContent 호출됨', {
      isConfirmation,
      hasApplication,
      hasDraft,
      actionType
    });
    if (isConfirmation) {
      if (actionType === 'draft') {
        // 초안 저장
        return {
          title: 'Draft Saved',
          message: 'Your draft has been saved successfully. Please note that this is not a final submission. You must submit your application before the deadline. Applications not submitted by the deadline will not be considered.',
          confirmText: 'OK'
        };
      } else if (actionType === 'submit') {
        if (hasApplication) {
          // 기존 신청서가 있고 수정한 경우
          return {
            title: 'Success',
            message: 'Your application has been updated successfully.',
            confirmText: 'OK'
          };
        } else {
          // 초안이 있거나 신규 제출한 경우
          return {
            title: 'Application Submitted',
            message: 'Your application has been successfully submitted. Thank you for applying to K-Startup Grand Challenge.',
            confirmText: 'OK'
          };
        }
      } else {
        // 기본 확인 메시지
        return {
          title: 'Success',
          message: 'Operation completed successfully.',
          confirmText: 'OK'
        };
      }
    } else {
      // 변경사항 저장 전 확인
      return {
        title: 'Navigate Away?',
        message: 'If you navigate away without saving, all your current information will not be saved.',
        warning: 'Unsaved data cannot be recovered.',
        confirmText: hasApplication ? 'Submit & Navigate' : 'Save Draft & Navigate'
      };
    }
  };

  const content = getModalContent();

  // 모달 외부 클릭 방지를 위한 이벤트 핸들러
  const handleOverlayClick = (e) => {
    // 모달 내부 클릭은 처리하지 않음
    if (e.target === e.currentTarget) {
      // 모달 외부 클릭 시 아무 동작도 하지 않음
      e.stopPropagation();
    }
  };

  return (
    <div 
      className="modal-overlay" 
      onClick={handleOverlayClick}
      style={{ 
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999
      }}
    >
      <div 
        className="modal-content"
        style={{
          backgroundColor: '#fff',
          padding: '30px',
          borderRadius: '8px',
          maxWidth: '500px',
          width: '90%',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
        }}
      >
        <h2>{content.title}</h2>
        <p>{content.message}</p>
        {content.warning && <p className="warning">{content.warning}</p>}
        <div className="modal-buttons">
          {!isConfirmation && (
            <button 
              className="modal-button cancel" 
              onClick={onCancel}
              style={{
                backgroundColor: '#f3f4f6',
                color: '#1f2937',
                border: 'none',
                padding: '10px 16px',
                borderRadius: '4px',
                cursor: 'pointer',
                marginRight: '10px'
              }}
            >
              Cancel
            </button>
          )}
          <button 
            className="modal-button save" 
            onClick={onConfirm}
            style={{
              backgroundColor: '#2563eb',
              color: 'white',
              border: 'none',
              padding: '10px 16px',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            {content.confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

SaveConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  hasApplication: PropTypes.bool,
  hasDraft: PropTypes.bool,
  isConfirmation: PropTypes.bool,
  actionType: PropTypes.oneOf(['navigate', 'draft', 'submit'])
};

export default SaveConfirmModal; 